import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-000802dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "!tw-text-[15px] tw-font-semibold tw-w-full tw-text-[#211F58]" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-w-full tw-h-[134px]"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-global-skeleton tw-w-full tw-h-full" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "tw-h-full tw-relative"
}
const _hoisted_6 = { class: "risk__content tw-z-1 tw-w-full tw-h-full" }
const _hoisted_7 = { class: "tw-font-[500] tw-text-[#211F58] tw-h-[20px] tw-text-[12px]" }
const _hoisted_8 = { class: "tw-flex tw-h-[20px] tw-text-[10px] tw-gap-[15px] tw-font-[500]" }
const _hoisted_9 = {
  key: 1,
  class: "tw-flex tw-gap-[6px] tw-items-center"
}
const _hoisted_10 = {
  key: 2,
  class: "tw-flex tw-gap-[6px] tw-items-center"
}
const _hoisted_11 = {
  key: 3,
  class: "tw-flex tw-gap-[6px] tw-items-center"
}
const _hoisted_12 = {
  key: 4,
  class: "tw-flex tw-gap-[6px] tw-items-center"
}
const _hoisted_13 = {
  key: 5,
  class: "tw-flex tw-gap-[6px] tw-items-center"
}
const _hoisted_14 = {
  key: 0,
  class: "tw-flex tw-opacity-50"
}
const _hoisted_15 = {
  key: 0,
  class: "dummy tw-px-[20px] tw-text-[13px] tw-font-[400] tw-text-[#211F58]"
}
const _hoisted_16 = {
  class: /*#__PURE__*/_normalizeClass(`tw-text-[#211F58] tw-font-[Poppins] tw-leading-[135%] tw-text-center title`)
}

import { PropType, Ref } from "vue";
import { getComponentUiText, getTagRelativeRisk } from "@/utils/utilities";
import { computed } from "vue";
import store from "@/store";
import StatusBadge from "../common/setting/statusBadge.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'risk',
  props: {
  score: {
    type: Boolean,
    default: true,
  },
  listRisk: {
    type: Array as PropType<any[]>,
    default: () => [],
  },
  typeStyle: {
    type: Boolean,
    default: false,
  },
  isActionTable: {
    type: [Boolean, Number],
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const listRiskRef = computed(() => {
  return props.listRisk;
});
const dataPercentile: Ref<any> = computed(() => {
  return store.state.Recommend.recommendPercentileChecklistGroupMetrics;
});

const dataPercentileTemplate: Ref<any> = computed(() => {
  return store.state.Recommend.percentileChecklistGroupTemplateMetrics;
});

const getBorder = (type: any, item: any) => {
  let style = "";
  switch (type) {
    case "low":
      if (!item.mediumNumber && !item.highNumber) {
        style +=
          "border-top-right-radius:10px ; border-bottom-right-radius:10px;";
      }
      break;
    case "medium":
      if (!item.highNumber) {
        style +=
          "border-top-right-radius:10px ; border-bottom-right-radius:10px;";
      }
      if (!item.lowNumber) {
        style +=
          "border-top-left-radius:10px ; border-bottom-left-radius:10px;";
      }
      break;
    case "high":
      if (!item.mediumNumber && !item.lowNumber) {
        style +=
          "border-top-left-radius:10px ; border-bottom-left-radius:10px;";
      }
      break;
  }
  return style;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "recommend-risk",
    class: _normalizeClass(["risk", `${!__props.score ? 'tw-h-[100%] tw-flex tw-flex-col' : ''}`])
  }, [
    _createElementVNode("div", {
      id: "recommend-title-risk",
      class: _normalizeClass(`${
        __props.typeStyle
          ? 'tw-p-[20px] tw-h-[56px] tw-bg-[#FCFCFD]'
          : 'tw-px-[20px] tw-pt-[20px] tw-pb-[10px] tw-h-[46px]'
      } tw-flex tw-items-center tw-justify-between`),
      style: _normalizeStyle(`border-bottom: ${__props.typeStyle ? '1px solid #eff0f1' : 'none'}`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-assess-recommendations-title-risk-1")), 1)
        ])
      ])
    ], 6),
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRiskRef.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(`tw-px-[20px]  ${
            __props.typeStyle ? 'tw-h-[48px] tw-py-[14px]' : 'tw-h-[69px] tw-py-[12px]'
          }  tw-flex-row tw-gap-[15px]`),
                style: _normalizeStyle(` ${
            index !== listRiskRef.value.length - 1
              ? 'border-bottom: 1px solid #eff0f1'
              : ''
          } `)
              }, [
                _createElementVNode("div", {
                  style: {"line-height":"20px"},
                  class: _normalizeClass(`tw-flex tw-justify-between ${
              __props.typeStyle ? '' : 'tw-pb-[12px]'
            }`)
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.text), 1),
                  _createElementVNode("div", _hoisted_8, [
                    (item.lowNumber || !item.isReduction)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(`tw-flex tw-gap-[6px] tw-items-center ${
                  __props.typeStyle ? 'tw-text-[#231f20]' : ''
                } `)
                        }, [
                          _createElementVNode("div", {
                            style: _normalizeStyle(`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgLow}; opacity: 0.5`)
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(item.lowNumber), 1)
                        ], 2))
                      : _createCommentVNode("", true),
                    (item.mediumNumber || !item.isReduction)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", {
                            style: _normalizeStyle(`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgMedium}; opacity: 0.5`)
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(item.mediumNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.highNumber || !item.isReduction)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", {
                            style: _normalizeStyle(`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgHigh}; opacity: 0.5`)
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(item.highNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                  item.relaModerateNumber ||
                  (!item.isReduction && item.isRelative)
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", {
                            style: _normalizeStyle(`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgRelaModerate}; opacity: 0.3`)
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(item.relaModerateNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                  item.relaHighNumber || (!item.isReduction && item.isRelative)
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", {
                            style: _normalizeStyle(`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgRelaHigh}; opacity: 0.6`)
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(item.relaHighNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                  item.relaHighestNumber ||
                  (!item.isReduction && item.isRelative)
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", {
                            style: _normalizeStyle(`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgRelaHighest};`)
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(item.relaHighestNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!item?.isRelativeRisk && item.isReduction)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 6,
                          class: "tw-flex tw-items-center tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-justify-center",
                          style: _normalizeStyle(`background-color:${item.bgText}; color:${item.colorText}; border-radius:4px`)
                        }, _toDisplayString(item.textStatus), 5))
                      : _createCommentVNode("", true),
                    (item?.isRelativeRisk)
                      ? (_openBlock(), _createBlock(StatusBadge, {
                          key: 7,
                          value: 
                  _unref(getTagRelativeRisk)(
                    item.value,
                    __props.isActionTable ? dataPercentile.value : dataPercentileTemplate.value,
                  ) ?? ''
                ,
                          class: "tw-w-fit"
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                (!item.isReduction)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", {
                        style: _normalizeStyle(`height: 7px; flex:${item.lowNumber}; background-color:${
                item.bgLow
              }; border-top-left-radius:10px ; border-bottom-left-radius:10px;
                ${getBorder('low', item)}
              `)
                      }, null, 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle(`height: 7px; flex:${
                item.mediumNumber
              }; background-color:${item.bgMedium}; ${getBorder(
                'medium',
                item,
              )} `)
                      }, null, 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle(`height: 7px; flex:${item.highNumber}; background-color:${
                item.bgHigh
              }; ${getBorder(
                'high',
                item,
              )}; border-top-right-radius:10px ; border-bottom-right-radius:10px`)
                      }, null, 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle(`height: 7px; flex:${
                item.relaModerateNumber
              }; background-color:${item.bgRelaModerate}; opacity: 0.3;
              border-top-left-radius:10px ; border-bottom-left-radius:10px;
              ${
                !item.relaHighNumber && !item.relaHighestNumber
                  ? 'border-top-right-radius:10px ; border-bottom-right-radius:10px'
                  : 'border-top-left-radius:10px ; border-bottom-left-radius:10px;'
              }`)
                      }, null, 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle(`height: 7px; flex:${
                item.relaHighNumber
              }; background-color:${item.bgRelaHigh}; opacity: 0.6;
              ${
                !item.relaModerateNumber || !item.relaHighestNumber
                  ? 'border-radius:10px;'
                  : !item.relaModerateNumber
                    ? 'border-top-left-radius:10px ; border-bottom-left-radius:10px'
                    : !item.relaHighestNumber
                      ? 'border-top-right-radius:10px ; border-bottom-right-radius:10px'
                      : ''
              }`)
                      }, null, 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle(`height: 7px; flex:${
                item.relaHighestNumber
              }; background-color:${item.bgRelaHighest}; opacity: 1; 
              border-top-right-radius:10px ; border-bottom-right-radius:10px; ${
                !item.relaModerateNumber && !item.relaHighNumber
                  ? 'border-top-left-radius:10px ; border-bottom-left-radius:10px'
                  : 'border-top-right-radius:10px ; border-bottom-right-radius:10px'
              }`)
                      }, null, 4)
                    ]))
                  : _createCommentVNode("", true)
              ], 6))
            }), 128))
          ]),
          (!__props.score)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(getComponentUiText)("app-assess-recommendations-risk-no-data-risk-1")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}
}

})